import { render } from "./BackspaceOutline.vue?vue&type=template&id=1c984d0e"
import script from "./BackspaceOutline.vue?vue&type=script&lang=js"
export * from "./BackspaceOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__